import React from 'react';
import { Link } from 'react-router-dom';

const productLinks = [
  { label: 'Path View', to: '/products/path-view' },
  { label: 'Restomatic', to: '/products/restomatic' },
  { label: 'All products', to: '/products' },
];

export default function Footer() {
  return (
    <footer className="sync-footer">
      <div className="sync-shell sync-footer-grid">
        <div className="sync-footer-brand">
          <img src="/assets/img/nalexus-logo-tp.png" alt="Nalexus Technologies" />
          <p>Software that runs businesses and institutions.</p>
          <a href="mailto:contact@nalexustechnologies.com">contact@nalexustechnologies.com</a>
        </div>

        <div>
          <h2>Build</h2>
          <Link to="/services">Solutions</Link>
          <Link to="/case-studies">Case Studies</Link>
          <Link to="/contact">Contact</Link>
        </div>

        <div>
          <h2>Products</h2>
          {productLinks.map((item) => <Link key={item.to} to={item.to}>{item.label}</Link>)}
        </div>

        <div>
          <h2>Company</h2>
          <Link to="/about">About</Link>
          <Link to="/academy">Academy</Link>
          <Link to="/articles">Insights</Link>
        </div>
      </div>

      <div className="sync-shell sync-footer-bottom">
        <p>© {new Date().getFullYear()} Nalexus Technologies</p>
        <div className="sync-footer-legal">
          <Link to="/privacy-policy">Privacy</Link>
          <Link to="/terms-and-conditions">Terms</Link>
          <a href="https://www.instagram.com/nalexus_technologies/" target="_blank" rel="noreferrer">Instagram</a>
          <a href="https://www.linkedin.com/company/nalexus-technologies/" target="_blank" rel="noreferrer">LinkedIn</a>
        </div>
      </div>
    </footer>
  );
}
